<script setup lang="ts">
const customize = (content: string) => {
	return content
		.replaceAll(/stroke-width="[^"]*"/g, '');
};
</script>

<template>
	<div class="flex size-full flex-col items-center justify-center gap-1 text-sm text-dimmed">
		<div>
			<DIcon name="lucide:triangle-alert" size="64" class="stroke-1 text-(--ui-border-accented)" mode="svg" :customize />
		</div>
		<div>
			{{ $t('failed_to_load_file') }}
		</div>
	</div>
</template>
